<template>
    <div>
        <div 
            class="font-size-title title-product px-8 px-sm-11" 
            v-html=selectProduct.product_name_web
            v-if="$vuetify.breakpoint.name=='sm' || $vuetify.breakpoint.name=='xs'"
        ></div>
        <v-row>
            <v-col cols="12" md=6 class='text-center'>
                <!-- <img 
                    :src="`${!!selectProduct.large_image_url ? urlApi+pathFileProducts+selectProduct.large_image_url : require('@/assets/ProductoSinImagen.jpg')}`" 
                    style="max-width:100%" 
                    class='p-0'
                > -->
                <pic-zoom 
                    :url="`${!!selectProduct.large_image_url ? urlApi+pathFileProducts+selectProduct.large_image_url : ''}`" 
                    :scale="2"
                    :scroll="true"
                    id="img_internal"
                ></pic-zoom>
            </v-col>
            <v-col cols="12" md=6 class='font-title title-product'>
                <!-- <h2 class='title-product font-size-title'>{{selectProduct.product_name_web}}</h2> -->
                <h1
                    
                    v-html=selectProduct.product_name_web
                    v-if="$vuetify.breakpoint.name=='md' || $vuetify.breakpoint.name=='lg'"
                ></h1>
                <h4 class="font-weight-light px-8 px-sm-11 px-md-0 mb-1">
                    <b class="font-weight-bold">Principio activo: </b> {{selectProduct.principio_activo}}
                </h4>
                <h4 class="font-weight-light px-8 px-sm-11 px-md-0 mb-1">
                   <b class="font-weight-bold">Laboratorio: </b> 
                   <a 
                        :href="`/medicamentos-especialidad?lab=${selectProduct.laboratory.toLowerCase()}`" 
                        v-if="selectProduct.laboratory=='BAGO'"
                        v-html=selectProduct.laboratory
                    ></a>
                   <span v-else v-html=selectProduct.laboratory></span>
                </h4>
                <h4 class="font-weight-light px-8 px-sm-11 px-md-0 mb-1">
                    <b class="font-weight-bold">Presentación: </b> {{selectProduct.presentacion}}
                </h4>
                <v-row 
                    v-if="selectProduct.psicotropico || selectProduct.controlado"
                >
                    <v-col 
                        v-if="selectProduct.controlado"
                        class="font-weight-light px-8 px-sm-11 px-md-0 col-md-4 col-12 col-sm-6">
                        <img 
                            src="../../../../assets/controlados.png"
                            style="width:30px"
                        > <span style="position: relative;bottom: 9px;">Producto controlado</span>
                    </v-col>
                    <v-col 
                        v-if="selectProduct.psicotropico"
                        class="font-weight-light px-8 px-sm-11 px-md-0 col-md-4 col-12 col-sm-6">
                        <img 
                            
                            src="../../../../assets/psicotropicos.png"
                            style="width:30px"
                        > <span style="position: relative;bottom: 8px;">Producto psicotropico</span>
                    </v-col>
                    <v-col class="font-weight-bold px-8 px-sm-11 px-md-0 col-md-4 col-12 col-sm-6 mt-1">
                        (Requiere receta médica)
                    </v-col>
                </v-row>
                
                <p class='px-10 px-md-0'><b>Descripción</b></p>
                <p class='font-weight-thin px-10 px-md-0' v-html=selectProduct.short_description></p>
                <!-- <div class='text-decoration-line-through d-inline'>U$D 300 </div>
                <div class='title-product d-inline ml-3 font-weight-bold font-size-title'>U$D 230</div -->
                <div class="px-10 px-md-0">
                    <v-btn depressed color="primary" outlined rounded @click="dialogInformation =!dialogInformation">
                        INFORMACIÓN DETALLADA
                    </v-btn>
                </div>
                <v-row>
                    <v-col md=4 sm=6 class="pl-13 px-md-3">
                        <div style='border:3px solid #50c995' class="rounded-xl text-caption text-center py-1">
                            <v-icon 
                                class="primary--text px-2 px-sm-6 px-lg-6 px-md-2"
                                @click="quantity('-')"
                            >mdi-minus mdi-18px</v-icon> 
                            <span class='font-weight-black gray--text'>{{cant}}</span>
                            <v-icon 
                                class="primary--text px-2 px-sm-6 px-lg-6 px-md-2"
                                @click="quantity('+')"
                            >mdi-plus mdi-18px</v-icon>
                        </div>
                        <div class='text-center'>Unidades</div>
                    </v-col>
                    <v-col md=8 sm=6 class="text-sm-left text-center">
                        <v-btn
                            rounded
                            color="#26aeea"
                            class='white--text mx-4 px-12 font-weight-bold font-italic text-capitalize'
                            @click="addProducts"
                        ><h2>Agregar</h2></v-btn>
                        <div 
                            class='mx-4'
                            v-if="selectProduct.controlado!=null"
                        ></div>
                    </v-col> 
                </v-row>
            </v-col>
        </v-row>
        <v-dialog
            v-model="dialogInformation"
            width="500"
        >
            <v-card>
                <v-card-title class="font-weight-bold title-product">INFORMACIÓN DETALLADA</v-card-title>            
                <v-card-text v-html=selectProduct.long_description></v-card-text>
                <v-col class="text-center">
                    <v-btn color="primary" class="mx-2" small @click="dialogInformation = false">
                    <v-icon >mdi-cancel</v-icon> Cerrar
                </v-btn>
                </v-col>
            </v-card>
        </v-dialog>
       <!--  <v-row>
            <v-col cols=12 style="max-width: 85%;margin: 0 auto;">
                <v-tabs  v-model="tab">
                    <v-tab class="font-weight-bold title-product">INFORMACIÓN DETALLADA</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card flat>
                        <v-card-text v-html=selectProduct.long_description></v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row> -->
        <div v-if="productsComplement.length" >
            <div>
                <v-col class='secction-other-products font-title font-italic'>
                    <v-col :style="`margin: 0 auto;width: ${$vuetify.breakpoint.width <= 640 ? '94%' : '87%'};`">
                        <div class='text-h5 text-md-h4 font-weight-black'>Otros productos que te pueden interesar:</div >
                    </v-col>
                </v-col>
            </div>
            <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 mt-16">
                <v-flex>
                    <template slot:default>
                        <v-carousel hide-delimiters>
                            <v-carousel-item v-for="i in cantCarrousel" :key="i" style="width: 90%;margin: 0 auto;">
                                <v-layout >
                                    <v-flex sm=2 v-for="(p, j) in productsComplement[i-1]" :key="j" px-2>
                                        <v-card elevation="0" v-if="p.product_name_web!=''" light>
                                            <img
                                                :src="!!p.medium_image_url ? (urlApi+pathFileProducts+p.medium_image_url) : require('@/assets/ProductoSinImagen.jpg')"
                                                style="width:100%;margin:0 auto;cursor:pointer;"
                                                @click="redirectRelatedProduct(p.product_id)"
                                                :alt="p.product_name_web"
                                            >
                                            <div class='text-center'>
                                                <div  class='grayblack--text font-title' style="height: 80px;"> </div>
                                                <v-btn 
                                                    rounded outlined 
                                                    class='btn-quote-products font-title font-weight-black'
                                                    @click="addOtherProducts(p)"
                                                > COTIZAR </v-btn>
                                            </div>
                                        </v-card>
                                        <v-card light elevation="0" v-else>
                                            <img :src="require('@/assets/blanco.png')" style="width:100%">
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-carousel-item>
                        </v-carousel>
                    </template>
                </v-flex>
            </div>
        </div>
        <!-- <div class='mb-16 mt-10'>
            <v-col class='secction-other-products font-title font-italic'>
                <v-col style='margin: 0 auto;width: 87%;'>
                    <div class='text-h5 text-md-h4 font-weight-black'>Quienes vieron este producto tambien compraron:</div >
                </v-col>
            </v-col>
        </div>
        <v-col style="position: relative;top: 107px;padding-left:0;padding-right:0">
            <v-flex class='mx-5 mx-sm-10 mx-md-16 px-md-16'>
                <v-carousel hide-delimiters>
                    <v-carousel-item v-for="i in cantCarrousel2" :key="i" style="width: 90%;margin: 0 auto;">
                        <v-layout >
                            <v-flex sm=2 v-for="(os , j) in alsoBouht[i-1]" :key="j" px-2>
                                <v-card elevation="0" light>
                                     <v-img
                                        :src="!!os.medium_image_url ? (urlApi+pathFileProducts+os.medium_image_url) : require('@/assets/ProductoSinImagen.jpg')"
                                        width="300px"
                                        style="margin:0 auto"
                                    ></v-img>
                                    <div class='text-center'>
                                        <div  class='grayblack--text font-title' v-html=os.product_name_web> </div>
                                        <v-btn 
                                            rounded 
                                            outlined 
                                            class='btn-quote-products font-title font-weight-black'
                                            @click=addOtherProducts(os)
                                        >
                                            COTIZAR
                                        </v-btn>
                                    </div>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-carousel-item>
                </v-carousel>
            </v-flex>
        </v-col> -->
    </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import PicZoom from 'vue-piczoom'
import Vue from 'vue'

export default {
    metaInfo () {
        return {
            title: `GRUPO INNOFARM - ${this.titlePage}`,
            meta:[
                {
                    name: 'description', 
                    content: this.metaContent
                },
                {
                    name: 'keywords', 
                    content: this.titlePage.split(' ').join(',')
                }
            ],
            bodyAttrs: {
                class: 'child-component'
            },
            afterNavigation () {
               // metaUpdated = 'yes'
            }
        }
    },
    name : "InternalProductComponent",
    components: {
        PicZoom
    },
    data:function(){
        return {
            titlePage: '',
            metaContent: '',
            cant:1,
            cantCarrousel:0,
            cantCarrousel2:0,
            tab:null,
            dialogInformation:false,
            productsComplement:[],
            alsoBouht:[],
            selectProduct:{
                forma_farmaceutica: "",
                htmlContent: "",
                internal_name: "",
                marca: "",
                presentacion: null,
                principio_activo: "",
                und: "",
            }
        }
    },
    computed:{
        
        ...mapState(['shoppingCar','selectedProducts','urlApi','pathFileProducts','sweeAlertAddProduct'])

    },
    methods:{

        ...mapMutations(['itemShoppingCar','setTotalQuantity','setUrl','setSelectedProducts','setLastProductsVisited']),

        ...mapActions(['requestApi','dataCarousel']),

        dataProduct(){
            
            this.setUrl(`busqueda-catalogo/${this.$route.params.producId}`)
            this.requestApi({
				method: 'GET',
				data :{}
			}).then(res =>{
                
                this.selectProduct = res.data.product
                document.getElementsByTagName('img')[7].setAttribute('alt',this.selectProduct.product_name_web)
                this.titlePage = this.selectProduct.product_name_web
                const regex = /(<p>|<\/p>|<strong>|<\/strong>|<h1>|<\/h1>|<h2>|<\/h2>|<h3>|<\/h3>|<h4>|<\/h4>|<h5>|<\/h5>|<h6>|<\/h6>|<li>|<\/li>|<ul>|<\/ul>|<ol>|<\/ol>|<u>|<\/u>|<s>|<\/s>|<em>|<\/em>)/ig;
                this.metaContent = this.selectProduct.short_description.replaceAll(regex,'')
                
                this.dataCarousel({
                    selectProduct:res.data.product.interestingProducts,
                    width: this.$vuetify.breakpoint.width
                }).then( res => {
                    this.cantCarrousel = res.cantCarrousel
                    this.productsComplement = res.productsComplement
                })

			})
            
        },

        quantity(operator){

            console.log(operator)
            if(operator == '+'){
                this.cant+=1
            }else{
                this.cant-=1
            }       
         
        },

        addProducts(){

            let existShoppingCar = this.shoppingCar.find(e => e.product_id == this.$route.params.producId)
            
            if(typeof existShoppingCar != 'undefined'){

                let index = this.shoppingCar.indexOf(existShoppingCar)
                this.shoppingCar[index].quantity += this.cant

            }else{

                this.setSelectedProducts({
                    product_id: this.$route.params.producId,
                    internal_name: this.selectProduct.product_name_web,
                    quantity: this.cant,
                    images: this.selectProduct.medium_image_url
                })

            }

            this.setTotalQuantity(this.cant)
            this.itemShoppingCar(this.selectedProducts)

            this.cant=1

            Vue.swal({...this.sweeAlertAddProduct})
        },

        addOtherProducts({product_id,product_name_web,medium_image_url}){
           
            this.setSelectedProducts({
                product_id: product_id,
                internal_name: product_name_web,
                quantity: 1,
                images: medium_image_url
            })

            this.setTotalQuantity(this.cant)
            this.itemShoppingCar(this.selectedProducts)

            this.cant=0 

        },

        redirectRelatedProduct(product_id){
            location.href = `/medicamentos-especialidad/producto/${product_id}`
        }

    },
    updated(){
        this.setLastProductsVisited({product_id:this.$route.params.producId})
    },

    mounted(){
        this.dataProduct()
    }
}
</script>

<style scope>
    .title-product{
        color:#5d5d5d
    }

    .font-size-title{
        font-size: 2rem;
    }

    .mouse-cover-canvas{
        border: 0px!important;
    }

    @media(max-width: 640px){
        .font-size-title {
            font-size: 1rem;
        }
    }

    .v-window{
        height:300px!important;
    }

    div.magnifier-box > div{
        width: 200px!important;
        height: 200px!important;
    }
    
</style>